export const FACET_LIMITS = {
    FILTER: 10,
    SCROLLBAR: 5,
    COLLAPSE: 0
  };
  
  export const FACET_ELEMENTS = {
    FILTER: 'FILTER',
    SCROLLBAR: 'SCROLLBAR',
    COLLAPSE: 'COLLAPSE'
  };